// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_b2-2";
export var aiChatCartContainerExit = "_b2-4";
export var aiChatContainerLarge = "_b2-0";
export var aiChatContainerSmall = "_b2-1";
export var aiChatIcon = "_b2-6";
export var slideInFromRight = "_b2-3";
export var slideOutToRight = "_b2-5";